export const ROUNDING_FACTOR = {
  ROUND: "round",
  ROUND_DOWN: "round_down",
  TENTH: "tenth",
  TENTH_DOWN: "tenth_down",
  HUNDRETH: "hundreth",
  THOSANDTH: "thousandth",
  NONE: "none",
};
